<div class="flex flex-row items-center gap-4">
    <button class="primary-btn my-4" (click)="addNewVideoTemplate()">Add Video
        Template</button>
</div>

<mat-table [dataSource]="dataSource" matSort
    class="!w-full !inline-table table-alternate">

    <ng-container matColumnDef="createomate_id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="createomate_id">
            ID
        </th>
        <td mat-cell *matCellDef="let element">
            {{ element.createomate_id }}
        </td>
    </ng-container>

    <ng-container matColumnDef="template_id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="template_id">
            Video Template ID
        </th>
        <td mat-cell *matCellDef="let element">
            {{ element.template_id }}
        </td>
    </ng-container>

    <ng-container matColumnDef="feed">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="feed">
            Category
        </th>
        <td mat-cell *matCellDef="let element">
            {{ element.feed }}
        </td>
    </ng-container>

    <ng-container matColumnDef="slides_number">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="slides_number">
            Slide Number
        </th>
        <td mat-cell *matCellDef="let element">
            {{ element.slides_number }}
        </td>
    </ng-container>

    <ng-container matColumnDef="template_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="template_name">
            Video Template Name
        </th>
        <td mat-cell *matCellDef="let element">
            {{ element.template_name }}
        </td>
    </ng-container>

    <ng-container matColumnDef="isApproved">
        <th mat-header-cell *matHeaderCellDef
            mat-sort-header="isApproved">Approval Status</th>
        <td mat-cell *matCellDef="let element">
            <mat-form-field appearance="outline" class="w-40 mt-3">
                <mat-select [(ngModel)]="element.isApproved"
                    (selectionChange)="onStatusChange(element)"
                    class="flex justify-center">
                    <mat-option *ngIf="element.isApproved === 'Pending'"
                        value="Pending">Pending</mat-option>
                    <mat-option value="Approved">Approved</mat-option>
                    <mat-option value="Not Approved">Not Approved</mat-option>
                </mat-select>
            </mat-form-field>
        </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Delete</th>
        <td mat-cell *matCellDef="let element">
            <button mat-icon-button
                (click)="$event.stopPropagation();openDeleteVideoTemplateConfirm(element)"
                class="!bg-red-500 !text-white">
                <mat-icon>delete</mat-icon>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</mat-table>

<mat-paginator [length]="totalItems" [pageSize]="12" showFirstLastButtons>
</mat-paginator>

<ng-template #videoFormTmpl let-dialogData="data">
    <app-video-template-form [formData]="video"
        (onSubmitClbk)="onSubmitClbk()"
        [companyID]="video.createomateCompanyID">
    </app-video-template-form>
</ng-template>

<ng-template #confirmDeleteTmpl>
    <div class="flex flex-col gap-4">
        <p>Are you sure you want to delete <b>{{ video.template_name }}</b>?</p>
        <div class="flex flex-row items-center justify-center gap-2">
            <button mat-button (click)="deleteVideoTemplate()">Confirm</button>
            <button mat-button (click)="dialog.closeAll();">Cancel</button>
        </div>
    </div>
</ng-template>